module.exports = __webpack_public_path__ + "static/media/iconfinder_Close_1031533.c370d29c.svg";